import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import LogoStrip from "@/components/LogoStrip";
import WhoIWorkWithSection from "@/components/WhoIWorkWithSection";
import WhatIHelpWithSection from "@/components/WhatIHelpWithSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import WhyThisApproachSection from "@/components/WhyThisApproachSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ProductsSection from "@/components/ProductsSection";
import AboutSection from "@/components/AboutSection";
import Footer from "@/components/Footer";
import PageSeo from "@/components/PageSeo";
import { useLanguage } from "@/i18n/LanguageContext";

const Index = () => {
  const { t } = useLanguage();

  return (
    <main className="min-h-screen">
      <PageSeo
        title={t("seo.home.title")}
        description={t("seo.home.description")}
        path="/"
      />
      <Navigation />
      <HeroSection />
      <LogoStrip />
      <WhoIWorkWithSection />
      <WhatIHelpWithSection />
      <HowItWorksSection />
      <WhyThisApproachSection />
      <TestimonialsSection />
      <ProductsSection />
      <AboutSection />
      <Footer />
    </main>
  );
};

export default Index;

